/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-04-16 15:21:49
 */
export default [
  {
    path: '/helpPrint',
    name: 'helpPrint',
    hidden: false,
    meta: {
      title: '助印管理',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/helpPrintIndex',
        name: 'helpPrintIndex',
        hidden: false,
        meta: {
          title: '助印管理',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/help-print-manage/manage'], resolve)
      },
      {
        path: '/helpPrintDetail',
        name: 'helpPrintDetail',
        hidden: true,
        meta: {
          title: '查看详情',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/help-print-manage/detail'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-print-manage.js